import { useContext, useEffect } from 'react';

import { CMSSection } from '@/cms/CMSSection';
import { getRegionFromLocale } from '@/lib/regions';
import { generateDataTestId } from '@/lib/tests';
import { LocaleContext } from '@/providers/LocaleProvider';

export const WidgetMoonphase = () => {
  const locale = useContext(LocaleContext);
  const region = getRegionFromLocale(locale);

  useEffect(() => {
    import('./widget-stenciljs-breitling/widget-stenciljs-breitling.esm.js');
  }, []);

  return (
    <CMSSection
      {...generateDataTestId('Moonphase', 'section')}
      data-test-id='MoonPhaseSection'
    >
      <widget-moonphase locale={region.locale.slug}></widget-moonphase>
    </CMSSection>
  );
};
